import { ElementRef } from '@angular/core'
import { TlwBaseCompnent } from './tlw-base.component'
import { FormDirective } from './html-directives/form.directive'

export abstract class TlwFormChildComponent extends TlwBaseCompnent {
  constructor(element: ElementRef, public parentForm: FormDirective) {
    super(element)
  }
}
